var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewResourceMaterial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-747 -276) translate(0 120) translate(748 157)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.889,
    cy: 52.889,
    r: 19.111,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M52.444 43.556L52.444 62.222M43.556 53.333L62.222 53.333M27.811 62.222H4.768C2.135 62.222 0 60.08 0 57.436V4.786C0 2.143 2.135 0 4.768 0H38.55c1.264.001 2.476.506 3.37 1.404l9.128 9.161c.894.898 1.396 2.116 1.395 3.386v13.97"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.422 13.33l-1.44-1.435c-2.388 1.144-5.237.659-7.11-1.21C-.004 8.816-.497 5.97.64 3.58L2.6 5.533c.523.535 1.294.749 2.018.559.724-.19 1.29-.755 1.483-1.48.192-.723-.019-1.494-.553-2.02L3.59.64C5.976-.5 8.822-.015 10.695 1.853c1.872 1.868 2.365 4.713 1.23 7.102l1.334 1.33M20.064 17.062l1.955 1.95c2.386-1.143 5.234-.658 7.108 1.21.413.411.76.871 1.036 1.363.065.117-2.609 2.438-4.163 4.415-1.657 2.108-2.592 4.738-2.7 4.713-1.108-.258-2.15-.819-2.994-1.66-1.872-1.868-2.365-4.713-1.231-7.102l-1.955-1.95M.987 30.075h0c-.58-.576-.906-1.36-.906-2.177 0-.818.326-1.601.906-2.178l6.455-6.443c.403-.401 1.054-.401 1.457 0l2.912 2.903c.193.192.301.453.301.726 0 .272-.108.533-.301.726l-6.457 6.443c-1.208 1.202-3.16 1.202-4.367 0zM21.806.633L30.36 9.16c.386.384.603.906.603 1.45 0 .546-.217 1.068-.603 1.452l-2.911 2.905c-.805.803-2.108.803-2.913 0l-8.553-8.524c-.387-.385-.604-.907-.604-1.452 0-.545.217-1.067.604-1.451l2.91-2.903C19.698-.167 21-.168 21.806.633zM20.35 10.793L10.217 20.592",
    transform: "translate(11 16)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewResourceMaterial);
export default __webpack_public_path__ + "static/media/new-resource-material.ef959a9cc4b121e5af3c4396e9bbb20d.svg";
export { ForwardRef as ReactComponent };